import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 9H1v13h18v-2H3V9zm15-4V3c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H5v13h18V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z"
}), 'ShopTwoSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ShopTwoSharp.js
// module id = 6100
// module chunks = 2